export default "__VITE_ASSET__92579ed4__"